import { createFileRoute } from '@tanstack/react-router'
import { PageHeader } from '@/lib/page-header'

export const Route = createFileRoute('/_shell/')({
  component: DashboardPage,
})

function DashboardPage() {
  return (
    <div className="p-8">
      <PageHeader title="Oversigt" />
      <p className="text-muted-foreground">Vælg en sektion fra sidemenuen.</p>
    </div>
  )
}
